export const DATE_FORMATS = {
  YYYY_MM_DDTHH_mm_ss: "yyyy-MM-dd'T'HH:mm:ss",
  HH_mm: 'HH:mm',
  hh_mm_a: 'hh:mm a',
  MM_DD_YYYY_HH_mm_A: 'MM/dd/yyyy hh:mm a',
  MM_DD_YYYY_HH_mm: 'MM/dd/yyyy HH:mm',
  MM_DD_YYYY: 'MM/dd/yyyy',
  yyyy_MM_dd: 'yyyy-MM-dd',
};

export default DATE_FORMATS;
